import { render, staticRenderFns } from "./DolceGusto.vue?vue&type=template&id=606a298d&scoped=true&"
import script from "./DolceGusto.vue?vue&type=script&lang=js&"
export * from "./DolceGusto.vue?vue&type=script&lang=js&"
import style0 from "./DolceGusto.vue?vue&type=style&index=0&id=606a298d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a298d",
  null
  
)

export default component.exports